import { createFileRoute, redirect } from '@tanstack/react-router'
import { ScheduleList } from '@/features/hr-performance/schedule-list'
import { hasGrant } from '@/lib/me'

/** Route shell for review schedules (spec D2). The API enforces the cycle grants. */
export const Route = createFileRoute('/_authenticated/hr/performance/schedules')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'performance_cycle.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: ScheduleList,
})
